(function () {
    'use strict';

    angular
        .module('app.reCrawlPosts', [])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.reCrawlPosts', {
                    requireLogin: true,
                    url: 'admin/reCrawlPosts',
                    templateUrl: 'app/admin/manualPosts/reCrawlPosts/reCrawlPosts.html?app_v=deployDate',
                    data: {
                        authorizedRoles: ['Administrator'],
                        navMarker: ['admin', 'reCrawlPosts']
                    },
                    controller: 'reCrawlPostsCtrl'
                })
        }]);
})();